import React from 'react';
import cx from 'classnames';
import { Card } from '@xingternal/card';
import {
  SkeletonProfileImage,
  SkeletonBody,
  SkeletonButton,
} from '@xingternal/skeleton';

import styles from './EmployeesCardVerticalContainer.css';

const EmployeeCardSkeleton = () => (
  <Card className={cx(styles.card, styles.skeletonCard)}>
    <SkeletonProfileImage size="xxlarge" />
    <SkeletonBody variant="primary" size="small" />
    <SkeletonButton size="small" />
  </Card>
);

export default EmployeeCardSkeleton;
